import { createSlice } from '@reduxjs/toolkit';
import { localeSelector } from '../common/LocaleSelector';
import { MainState } from '../interface/ICommon';

const initialState: MainState = {
    config: {
        apiDomain: '',
        wstatic: '',
        locale: '',
        service: '',
    },
    now: '',
    serverList: [],
    serverListW: [],
    l10n: {},
};

const mainSlice = createSlice({
    name: 'mainSlice',
    initialState: initialState,
    reducers: {
        setConfig: (state, action) => {
            state.config = action.payload;
            let htmlEl = document.querySelector('html');
            state.config.locale = localeSelector(htmlEl!.getAttribute('lang') || 'ko');
        },
        setNow: (state, action) => {
            state.now = action.payload;
        },
        setServerList: (state, action) => {
            state.serverList = action.payload;
        },
        setServerListW: (state, action) => {
            state.serverListW = action.payload;
        },
        setL10n: (state, action) => {
            state.l10n = action.payload;
        },
    },
});

export const { setNow, setConfig, setServerList, setServerListW, setL10n } = mainSlice.actions;
export default mainSlice.reducer;
